// LivestreamViewerCameraController.js
'use strict';
import { connect } from 'react-redux';

import LivestreamViewerCameraController from '../component/LivestreamViewerCameraController.jsx';

import getLiveStreamData from '../selector/getLiveStreamData.js';
import getGoalData from '../selector/getGoalData.js';
import getNetworkingData from '../selector/getNetworkingData.js';
import getOperationData from '../selector/getOperationData.js';
import {
  getHasStreamToken,
  getIsMeExclusivePrivateGoalInitiator,
} from '../selector/getLivestreamComputedData.js';
import getTimestampOffset, {
  Accuracy,
} from '../selector/getTimestampOffset.js';

const mapStateToProps = (state, { streamId }) => {
  const currentGoalId = getLiveStreamData(
    state,
    [streamId, 'exclusivePrivate'],
    'currentId'
  );
  const sessionId = getLiveStreamData(state, [streamId], 'sessionId');
  return {
    isExclusiveViewer: getIsMeExclusivePrivateGoalInitiator(state, streamId),
    exclusivePrivateStatus: getLiveStreamData(
      state,
      [streamId, 'exclusivePrivate'],
      'status'
    ),
    performingStartUnix: getGoalData(state, [currentGoalId], 'nbf'),
    hasStreamToken: getHasStreamToken(state, streamId),
    // Entering PERFORMING clears the paid token then re-fetches it
    // (LiveStream.componentDidUpdate); this flag marks that transient window.
    isFetchingStreamToken: !!getNetworkingData(
      state,
      ['fetch', 'streamToken', sessionId],
      'isFetching'
    ),
    // fetchStreamsToken failure does not disable auto payment, so this error
    // is the signal that confirms the token is really lost (deduction failed).
    hasStreamTokenFetchError: !!getNetworkingData(
      state,
      ['fetch', 'streamToken', sessionId],
      'error'
    ),
    isAutoPaymentEnabled: !!getOperationData(
      state,
      ['liveStream', 'autoPayment', streamId],
      'isEnabled'
    ),
    timestampOffsetSeconds: getTimestampOffset(state, Accuracy.SECOND),
  };
};

export default connect(mapStateToProps)(LivestreamViewerCameraController);
